import { images } from '@/assets/images';
import moment from 'moment';
import debounce from 'lodash/debounce';
import CryptoJS from 'crypto-js';
import numeral from 'numeral';

export const GA_KEY = {
  DEV: 'G-2JWGZT7KTQ',
  PROD: 'G-35NTP2943K',
};

export const getImage = (key: string) => {
  switch (key) {
    case 'BSH':
    case 'CPD':
    case 'TPL':
      return images.BSH;
    case 'GIC':
    case 'PA':
      return images.GIC;
    case 'UIC':
    case 'HC':
      return images.UIC;
    case 'MSIG':
    case 'Travel':
      return images.MSIG;
    default:
      break;
  }
};

export const ORIGINS = {
  'en-US': [
    { label: 'Made in Vietnam', value: 1 },
    { label: 'Imported car', value: 2 },
  ],
  'vi-VN': [
    { label: 'Sản xuất tại Việt Nam', value: 1 },
    { label: 'Xe nhập khẩu', value: 2 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const VEHICLE_REG_DETAILS = {
  'en-US': [
    { label: 'Plate number', value: 1 },
    { label: 'Chassis number / Engine series number', value: 2 },
  ],
  'vi-VN': [
    { label: 'Biển số', value: 1 },
    { label: 'Số khung/Số máy', value: 2 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const TYPE_OF_VEHICLE = {
  'en-US': [
    { label: 'Non-business transport', value: 3 },
    { label: 'Business transport', value: 4 },
    { label: 'Non-business Pickup Car', value: 13 },
    { label: 'Business Pickup Car', value: 14 },
    { label: 'Taxi', value: 9 },
    { label: 'Ambulance', value: 5 },
    { label: 'Trailers', value: 7 },
    { label: 'Specialized motorcycle', value: 8 },
    { label: 'Money Truck', value: 6 },
    { label: 'Business Truck', value: 10 },
    { label: 'Non-business Truck', value: 11 },
    { label: 'Dump Truck', value: 12 },
  ],
  'vi-VN': [
    { label: 'Xe vận tải không kinh doanh', value: 3 },
    { label: 'Xe kinh doanh vận tải', value: 4 },
    { label: 'Xe khách không kinh doanh', value: 13 },
    { label: 'Xe khách thương mại', value: 14 },
    { label: 'Taxi', value: 9 },
    { label: 'Xe cấp cứu', value: 5 },
    { label: 'Xe rơ-móc', value: 7 },
    { label: 'Xe máy chuyên dụng', value: 8 },
    { label: 'Xe tải chở tiền', value: 6 },
    { label: 'Xe tải thương mại', value: 10 },
    { label: 'Xe tải không kinh doanh', value: 11 },
    { label: 'Xe tải tự đổ', value: 12 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const typeOfVehicleBSHCarPhysicalDamageOptions = {
  'en-US': [
    { label: 'Non-business transport', value: 3 },
    { label: 'Business transport', value: 4 },
    { label: 'Non-business Pickup Car', value: 13 },
    { label: 'Business Pickup Car', value: 14 },
  ],
  'vi-VN': [
    { label: 'Xe vận tải không kinh doanh', value: 3 },
    { label: 'Xe kinh doanh vận tải', value: 4 },
    { label: 'Xe khách không kinh doanh', value: 13 },
    { label: 'Xe khách thương mại', value: 14 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const notForPassengerSeatsOptions = [
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '12', value: 12 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '20', value: 20 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '35', value: 35 },
  { label: '40', value: 40 },
  { label: '45', value: 45 },
  { label: '50', value: 50 },
  { label: '55', value: 55 },
  { label: '60', value: 60 },
];

export const taxiSeatsOptions = [
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
];

export const pickUpOptions = [
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
];

export const allSeatsOptions = [
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
  { label: '32', value: 32 },
  { label: '33', value: 33 },
  { label: '34', value: 34 },
  { label: '35', value: 35 },
  { label: '36', value: 36 },
  { label: '37', value: 37 },
  { label: '38', value: 38 },
  { label: '39', value: 39 },
  { label: '40', value: 40 },
  { label: '41', value: 41 },
  { label: '42', value: 42 },
  { label: '43', value: 43 },
  { label: '44', value: 44 },
  { label: '45', value: 45 },
  { label: '46', value: 46 },
  { label: '47', value: 47 },
  { label: '48', value: 48 },
  { label: '49', value: 49 },
  { label: '50', value: 50 },
  { label: '51', value: 51 },
  { label: '52', value: 52 },
  { label: '53', value: 53 },
  { label: '54', value: 54 },
  { label: '55', value: 55 },
  { label: '56', value: 56 },
  { label: '57', value: 57 },
  { label: '58', value: 58 },
  { label: '59', value: 59 },
  { label: '60', value: 60 },
];

export const TONNAGE = {
  'en-US': [
    { label: `Under 3 tons`, value: 1 },
    { label: `From 3 To 8 tons`, value: 2 },
    { label: `Over 8 To 10 tons`, value: 3 },
    { label: `Over 10 To 15 tons`, value: 4 },
    { label: `Over 15 tons`, value: 5 },
  ],
  'vi-VN': [
    { label: `Dưới 3 tấn`, value: 1 },
    { label: `Từ 3 đến 8 tấn`, value: 2 },
    { label: `Từ 8 đến 10 tấn`, value: 3 },
    { label: `Từ 10 đến 15 tấn`, value: 4 },
    { label: `Trên 15 tấn`, value: 5 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const PLAN_FOR = {
  'en-US': [
    { label: `Individual`, value: 1 },
    { label: `Family`, value: 2 },
  ],
  'vi-VN': [
    { label: `Cá nhân`, value: 1 },
    { label: `Gia đình`, value: 2 },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const VEHICLE_RANGE = {
  'vi-VN': [
    { value: 1, label: 'Xe 2 bánh <= 50CC' },
    { value: 2, label: 'Xe 2 bánh > 50CC' },
    { value: 3, label: '3 bánh' },
    { value: 4, label: 'Xe máy điện' },
  ],
  'en-US': [
    { value: 1, label: '2 Wheeler <= 50CC' },
    { value: 2, label: '2 Wheeler > 50CC' },
    { value: 3, label: '3 Wheeler' },
    { value: 4, label: 'Electric Motorcycle' },
  ],
} as { [key: string]: Array<{ value: number; label: string }> };

export const TRAVEL_REGION = {
  'vi-VN': [
    {
      label: 'Đông Nam Á',
      value: 'SEA',
    },
    {
      label: 'Châu Á',
      value: 'Asia',
    },
    {
      label: 'Thế giới',
      value: 'Worldwide',
    },
  ],
  'en-US': [
    {
      label: 'Southeast Asia',
      value: 'SEA',
    },
    {
      label: 'Asia',
      value: 'Asia',
    },
    {
      label: 'Worldwide',
      value: 'Worldwide',
    },
  ],
} as { [key: string]: Array<{ value: string; label: string }> };

// 回车键监听
export const EnterKeyPressListener = (callback: (params?: any) => void) => {
  document.body.addEventListener('keydown', (e: KeyboardEvent) => {
    if (window.event) {
      e = e || window.event;
    }
    const code = e.code || e.keyCode || e.charCode;
    if (code === 'Enter' || code === 13) {
      callback();
    }
  });
};

export const getNationalPassportID = (policy: any) => {
  if (!policy) {
    return '';
  }

  if (!policy.customer_detail) {
    return '';
  }

  if (policy.customer_detail.id_number) {
    return policy.customer_detail.id_number;
  }

  if (policy.customer_detail.passport_number) {
    return policy.customer_detail.passport_number;
  }

  if (policy.customer_detail.id_or_passport_number) {
    return policy.customer_detail.id_or_passport_number;
  }

  return '';
};

// 列表滚动到底部加载数据
export const handleOnScroll = (getData: () => void) =>
  debounce(
    () => {
      const contentScrollTop = document.documentElement.scrollTop; //滚动条距离顶部
      const clientHeight = document.documentElement.clientHeight; //可视区域
      const scrollHeight = document.documentElement.scrollHeight; //滚动条内容的总高度

      if (contentScrollTop + clientHeight >= scrollHeight) {
        getData && getData();
      }
    },
    200,
    { leading: false, trailing: true },
  );

// 时间格式化
export const insuranceStartDateFormmat = (
  start_at: moment.Moment | string | number,
) => {
  const ymd = moment(start_at).format('YYYY-MM-DD');
  if (moment(start_at).isAfter(moment())) {
    // 选择的必须是当前日期的0时0分0秒
    return moment(ymd).unix();
  } else {
    // 如果选择的是今日时间，要精确到时分秒
    return moment(start_at).unix();
  }
};

// aes加密
export const aesEncrypt = (textStr: string): string => {
  if (!textStr) return '';

  const keyStr = '===paymentpasswordkey===';
  const ivStr = '===paymentpasswordiv===';

  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const iv = CryptoJS.enc.Utf8.parse(ivStr);
  const encrypted = CryptoJS.AES.encrypt(textStr, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

// aes解密
export const aesDecrypt = (textStr: string): string => {
  if (!textStr) return '';

  const keyStr = '===paymentpasswordkey===';
  const ivStr = '===paymentpasswordiv===';

  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const iv = CryptoJS.enc.Utf8.parse(ivStr);
  const decrypted = CryptoJS.AES.decrypt(textStr, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

// 解决大数危机
export const toPrecision = (num1: number, num2: number) => {
  const num1Digits = (num1.toString().split('.')[1] || '').length;
  const num2Digits = (num2.toString().split('.')[1] || '').length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (num1 * baseNum) / baseNum;
};

// HC Options
// export const HcOptions = {
//   'vi-VN': [
//     {
//       name: 'Lựa chọn 1',
//       key: '1',
//     },
//     {
//       name: 'Lựa chọn 2',
//       key: '2',
//     },
//     {
//       name: 'Lựa chọn 3',
//       key: '3',
//     },
//     {
//       name: 'Lựa chọn 4',
//       key: '4',
//     },
//     {
//       name: 'Lựa chọn 5',
//       key: '5',
//     },
//   ],
//   'en-US': [
//     {
//       name: 'Option 1',
//       key: '1',
//     },
//     {
//       name: 'Option 2',
//       key: '2',
//     },
//     {
//       name: 'Option 3',
//       key: '3',
//     },
//     {
//       name: 'Option 4',
//       key: '4',
//     },
//     {
//       name: 'Option 5',
//       key: '5',
//     },
//   ],
// } as { [key: string]: Array<{ name: string; key: string }> };

// HC Month Plan
export const HcMonthPlans = {
  'en-US': [
    {
      name: '3 Months',
      key: 3,
      note: 'For insurance contracts with an insurance term of 3 months: be paid up to 15 days',
    },
    {
      name: '6 Months',
      key: 6,
      note: 'For insurance contracts with an insurance term of 6 months: be paid up to 30 days',
    },
    {
      name: '12 Months',
      key: 12,
      note: 'For insurance contracts with an insurance term of 1 year: be paid up to 60 days',
    },
  ],
  'vi-VN': [
    {
      name: '3 Tháng',
      key: 3,
      note: 'Đối với HĐBH có thời hạn bảo hiểm 03 tháng: được chi trả tối đa 15 ngày trợ cấp viện phí cho một thời hạn bảo hiểm',
    },
    {
      name: '6 Tháng',
      key: 6,
      note: 'Đối với HĐBH có thời hạn bảo hiểm 6 tháng: được chi trả tối đa 30 ngày trợ cấp viện phí cho một thời hạn bảo hiểm',
    },
    {
      name: '12 Tháng',
      key: 12,
      note: 'Đối với HĐBH có thời hạn bảo hiểm 1 năm: được chi trả tối đa 60 ngày trợ cấp viện phí cho một thời hạn bảo hiểm',
    },
  ],
} as { [key: string]: Array<{ name: string; key: number; note: string }> };

// login的password加密
export const aesEncryptLoginPassWord = (textStr: string): string => {
  if (!textStr) return '';
  const envryptedString = CryptoJS.AES.encrypt(textStr, 'login_password');
  return envryptedString.toString();
};

// login的password解密
export const aesDecryptLoginPassWord = (textStr: string): string => {
  if (!textStr) return '';
  const decryptedString = CryptoJS.AES.decrypt(textStr, 'login_password');
  return decryptedString.toString(CryptoJS.enc.Utf8);
};

export const currencyFormat = (currency: string | number | undefined) => {
  const originCurrencyStr = Number(currency)?.toLocaleString('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });

  return originCurrencyStr
    ? originCurrencyStr.replace(/[^0-9.\,]/gi, '').slice(0)
    : '';
};

export const getSession = (name: string): { [key: string]: any } | null => {
  const store = sessionStorage.getItem(name);
  let value;
  try {
    value = store ? JSON.parse(store) : undefined;
  } catch {}
  return value;
};

export const isUndefined = (value: any) => {
  return typeof value === 'undefined';
};

export const deletePhsicalDamageParams = (params: { [prop: string]: any }) => {
  delete params['vehicle_value'];
  delete params['vehicle_origin'];
  delete params['registration_date'];
  delete params['manufacture_date'];
  return params;
};

export const covert2Million = (values: { [prop: string]: any }) => {
  // vehicle_value的单位是millions，自动补上百万单位的0
  if (typeof values?.vehicle_value !== 'undefined') {
    values.vehicle_value = numeral(values.vehicle_value ?? 0)
      .multiply(1000000)
      .value() as number;
  }
  return values;
};

export const covert2RemoveMillion = (values: { [prop: string]: any }) => {
  if (typeof values?.vehicle_value !== 'undefined') {
    values.vehicle_value = numeral(values.vehicle_value ?? 0)
      .divide(1000000)
      .value() as number;
  }
  return values;
};

//login password des-ecb 加密
export const desEncryptLoginPassword = (password: string): string => {
  if (!password) return '';
  return CryptoJS.DES.encrypt(
    password,
    CryptoJS.enc.Utf8.parse(LOGIN_PASSWORD_SECRET_KEY),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    },
  ).toString();
};
